<template>
  <b-form inline fluid>
    <b-input-group class="text-dark" :prepend="getLabel">
      <!-- Passphrase display field -->
      <b-input  @submit.prevent :type="passwordFiledType"
        :value="secret"
        class="text-dark"
        id="password-input"
        disabled = true
        aria-describedby="password-help-block"
        :class="{'form-control-sm' : small}"></b-input>

      <b-input-group-append>
        <!-- Reveal secret button -->
        <b-button @click="showSecret" variant="outline-primary" size="sm"  v-b-tooltip.hover.top :title="$t('unitSecret.showHideTT')">
          <b-icon :icon="viewPasswordIcon"></b-icon>
        </b-button>

        <WifiQRCodeViewer v-if="this.$store.getters.getPropertySingleSSID" :secretType="secretType"/>
        
        <!-- Update passphrase manually button -->
        <b-button v-if="this.showChange && this.$store.getters.getIsTenantSetSecret" @click="changeUnitSecret"  variant="outline-primary" size="sm" v-b-tooltip.hover.topright :title="getWifiChangeText">
          <b-icon icon="pencil-fill"> </b-icon>
        </b-button>

        <!-- Update passphrase automatically button -->
        <ChangeSecretButtonNoInput v-if="this.showChange && !this.$store.getters.getIsTenantSetSecret" :changeType="this.secretType" :tooltip="getWifiChangeText"/>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>

<script>
import router from "@/router";
import ChangeSecretButtonNoInput from '@/components/ChangeSecretButtonNoInput'
import WifiQRCodeViewer from '@/components/WifiQRCodeViewer'

export default {
  name: 'unitSecret',
  props: {
    secret: {type: String},
    secretType: {type: String},
    showChange: {type: Boolean,  default: false},
    small: {type: Boolean, default: false}
  },
  components:{
    ChangeSecretButtonNoInput,
    WifiQRCodeViewer
  },
  data: () =>({
    passwordFiledType: 'password',
    viewPasswordIcon: 'eye',
    newSecret: '',
    secretState: '',
  }),
  computed:{
    getLabel(){
      if(!this.showChange) {
        return "";
      }
      if(this.secretType === "IDENTITY"){
        return  this.$t('identity.passphrase')
      } else if(this.secretType === "UNIT") {
        return  this.$t('unitSecret.secret')
      }
      return  this.$t('unitSecret.guestSecret')
    },
    getWifiChangeText(){
      if(this.secretType === 'IDENTITY') {
        return this.$t('identity.resetPassphrase')
      } else if(this.secretType === "UNIT"){
        return this.$t('unitSecret.resetUnitPassPhrase')
      }
      return this.$t('unitSecret.resetGuest')
    }
  },
  methods: {
    showSecret() {
      if( this.passwordFiledType === 'password'){
        this.passwordFiledType = 'text'
        this.viewPasswordIcon = 'eye-slash'
      }else{
        this.passwordFiledType = 'password'
        this.viewPasswordIcon = 'eye'
      }
    },
    changeUnitSecret(){
      if(this.secretType === "UNIT") {
        router.push({name: 'ChangeUnitSecret', params: {changeRequested: "unitSecret"}})
      } else if(this.secretType === "IDENTITY") {
        router.push({name: 'ChangeUnitSecret', params: {changeRequested: "identitySecret"}})
      } else {
        router.push({name: 'ChangeUnitSecret', params: {changeRequested: "guestSecret"}})
      }
    }
  }
}
</script>

<style>
#qrSsidSecretModalUnit___BV_modal_outer_{
  z-index: 1999 !important;
}
#qrSsidSecretModalGuest___BV_modal_outer_{
  z-index: 1999 !important;
}
</style>